/*
 * AppVerifyStepTwo Messages
 *
 * This contains all the text for the AppVerifyStepTwo component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.AppVerifyStepTwo";

export default defineMessages(scope, {
  header: "This is the AppVerifyStepTwo component!",
  codeTextField: "Enter Code",
  backButtonLabel: "Back to QR Code",
  verifyButtonLabel: "Verify",
  cancelButtonLabel: "Cancel",
  invalidCodeErrorMessage: "Incorrect code. Please try again.",
});
